import Vue from 'vue'
import VueRouter from 'vue-router'
// import Dashboard from '../views/Dashboard.vue'
import Employees from '../views/employee/index.vue'
import Client from '../views/client/Client.vue'
import Unit from '../views/Unit.vue'
import ClientInfo from '../views/client/ClientInfo.vue'
import StaffInfo from '../views/StaffInfo.vue'
import Shifts from '../views/Shifts.vue'
import ShiftsForm from '../components/Shifts/ShiftForm.vue'
import ShiftsFormUpdate from '../components/Shifts/ShiftFormUpdate.vue'
import Login from '../views/Login.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ClockInTracker from '../views/ClockInTracker.vue'
import UserAuthLog from '../views/UserAuthLog.vue'
import Users from '../views/Users.vue'
import UserForm from '../components/UserForm.vue'
import UsersRoles from '../views/UsersRoles.vue'
import UserProfile from '../views/Userprofile.vue'
import Medications from '../views/client/Medications.vue'
import MedicationForm from '../views/client/Medication/MedicationForm.vue'
import MAR from '../views/client/MAR.vue'
// import MAR from '../views/client/MARs'
import Codes from '../views/Codes.vue'
import Certs from '../views/certifications/index.vue'
import ADL from '../views/client/ADL.vue'
import ServicePlan from "../views/client/ServicePlan"
import Support from "../views/client/Support"
import Attendance from "../views/client/Attendance.vue"
import AttendanceForm from "../views/client/Reporting/AttendanceForm.vue"
import Providers from "../views/client/Providers.vue"
import ProviderForm from "../views/client/Reporting/ProviderForm.vue"
import Incidents from "../views/client/Incidents.vue"
import IncidentForm from "../views/client/Incident/IncidentForm.vue"
import Rights from "../views/client/Rights.vue"
import HumanRightsRestrictionForm from "../views/client/Reporting/HumanRightsRestrictionForm.vue"
import Events from "../views/client/Events.vue"
import EventForm from "../components/events/EventForm.vue"
import Inventory from "../views/client/Inventory.vue"
import InventoryForm from "../views/client/Reporting/InventoryForm.vue"
import Diagnoses from "../views/client/Diagnoses.vue"
import DiagnosisForm from "../views/client/OnBoardInfo/DiagnosisForm.vue"
import Finances from "../views/client/Finances.vue"
import FinancesForm from "../views/client/Reporting/FinancesForm.vue"
import Assessments from "../views/client/Assessments.vue"
import AssessmentForm from "../views/client/OnBoardInfo/AssessmentForm.vue"
import AnnualDocs from "../views/client/AnnualDocs.vue"
import AnnualDocumentForm from "../views/client/OnBoardInfo/AnnualDocumentForm.vue"
import Reimbursements from "../views/Reimbursements.vue"
//import InserviceTraining from "../views/InserviceTraining.vue"

//import Adjustments from "../views/Adjustments.vue"
import WorkersComp from "../views/staff/WorkersComp"
import staffCertification from "../views/staffCertification.vue"
import ContactInfo from "../views/client/ContactInfo.vue"
import ContactInfoForm from "../views/client/OnBoardInfo/ContactInfoForm.vue"
import Notifications from "../views/Notifications.vue"
import Reports from "../views/Reports.vue"
import ClientTest from "../views/staff/ClientTests"
import MedVisit from "../views/client/MedVisit"
import VisitForm from "../views/client/MedVisit/MedicalVisitForm.vue"
import WeeklySummary from "../views/client/WeeklySummary.vue"
import WeeklySummaryForm from "../views/client/Reporting/WeeklySummaryForm.vue"
import BehaviorReport from "../views/client/BehaviorReport.vue"
import BehaviorReportForm from "../views/client/Reporting/BehaviorReportForm.vue"
import NewHirePortal from "../views/NewHirePortal.vue"
import Calendar from "../views/Calendar.vue"
import Consents from "../views/client/Consents.vue"
import Training from "../views/Training.vue"
import TrainingHistory from '../views/TrainingHistory.vue'
import DocumentLibrary from "../views/DocumentLibrary.vue"
import DocumentLibraryClient from "../views/client/DocumentLibraryClient.vue"
import ServiceCodes from "../views/client/ServiceCodes.vue"
import ServiceCodesForm from "../views/client/OnBoardInfo/ServiceCodesForm.vue"
import MonthlySummaries from "../views/client/MonthlySummary.vue"
import MonthlySummaryForm from "../views/client/Reporting/MonthlySummaryForm.vue"
import QuarterlySummaries from "../views/client/QuarterlySummary.vue"
import Survey from "../views/Survey.vue"
import Test from "../views/Test.vue"
import Behaviors from "../views/client/Behaviors.vue"
import BehaviorForm from "../views/client/OnBoardInfo/BehaviorForm.vue"
// import NewHirePortal1 from "../views/new_hire_portal/"
// import Zoom from "../views/Zoom.vue"
import Allergies from "../views/Allergies.vue"
import AllergiesForm from "../views/client/OnBoardInfo/AllergiesForm.vue"
import Chat from "../views/Chat"
import MedicationInventory from "../views/client/MedicationInventory"
import MedicationInventoryForm from "../views/client/Medication/MedicationInventoryForm.vue"
import Warning from "../views/client/Warning"
import WarningForm from "../views/client/OnBoardInfo/WarningForm.vue"
import Tasks from "../views/Tasks.vue"
import GlobalTraining from "../views/GlobalTraining.vue"
import NHO from "../views/NHO.vue"
import Secure from "../views/Secure.vue"
import PerformanceReview from "../views/PerformanceReview.vue"
import Review from "../views/Review.vue"
import RAD from "../views/client/RAD.vue"
import DOR from "../views/client/DOR.vue"
import FireDrill from "../views/client/FireDrill.vue"
import FireDrillForm from "../views/client/Reporting/FireDrillForm.vue"
import MonthlyChecklist from "../views/client/MonthlyChecklist.vue"
import Mileage from "../views/Mileage.vue"
import IncidentReport from "../views/Reports/Incidents.vue"
import IncidentReportGraphNew from "../views/Reports/IncidentReportGraphNew.vue"
import UpcomingEventsReport from "../views/Reports/UpcomingEventsReport.vue"
import MedicalVisitsReport from "../views/Reports/MedicalVisits.vue"
import AttendanceReport from "../views/Reports/Attendance.vue"
import ReportingBehaviors from "../views/Reports/BehaviorReports.vue"
import ADLReport from "../views/Reports/ADL.vue"
import UnsignedADLReport from "../views/Reports/UnsignedADL.vue"
import FinancesReport from "../views/Reports/Finances.vue"
import ExpiringDocuments from "../views/Reports/AnnualDocuments.vue"
import CompTests from "../views/Reports/CompTests.vue"
import ClientCompetencyTestForm from "../components/ClientCompetencyTestForm.vue"
import MissingCertifications from "../views/Reports/MissingCertifications.vue"
import StaffExpiring from "../views/Reports/StaffExpiring.vue"
import CertificationForm from "../components/Certfications.vue"
import StaffExpenses from "../views/Reports/StaffExpenses.vue"
import StaffReimbursementForm from "../components/StaffReimbursementForm.vue"
import MonthlyFire from "../views/Reports/MonthlyFire.vue"
import MARVerified from "../views/Reports/MARVerified.vue"
import MedicationReport from "../views/Reports/MedicationReport.vue"
import EVVReport from "../views/Reports/EVV.vue"
import FinanceTransactions from "../views/client/FinanceTransactions.vue"

import MedHandOff from "../views/client/Medication/MedHandOff"
import EmployeeEvaluation from "../views/EmployeeEvaluation.vue"
import TimeOff from "../views/TimeOff.vue"
import AddTimeOffRequest from "../components/TimeOffRequest/AddTimeOffRequestForm.vue"
import UpdateTimeOffRequest from "../components/TimeOffRequest/UpdateTimeOffRequestForm.vue"
import Payroll from "../views/Payroll.vue"
import NVIncidents from "../views/client/NVIncidents.vue"
import NVIncidentForm from "../views/client/NVIncident/NVIncidentForm.vue"
import HAB from "../views/client/HAB.vue"
import HABChart from "../views/client/HABChart"
import DataTracking from "../views/client/DataTracking.vue"
import Meals from "../views/client/MealPlan.vue"
import MealsForm from "../views/client/Reporting/MealPlanForm.vue"
import Communication from "../views/CommunicationLog.vue"
import CommunicationForm from "../views/ClientCommunication/form.vue"
import MileageTransactions from "../views/MileageTransactions.vue"
import GlobalProvider from "../views/client/GlobalProvider.vue"
import VehicleInspection from "../views/staff/VehicleInspection"
import Shared from "../views/Shared.vue"
import LinkError from "@/error/LinkError.vue"
import HRCReport from "../views/Reports/HRC.vue"
import HouseRepair from "../views/HouseMaintenance.vue"
import InitialJobPlacement from "../views/InitialJobPlacement.vue"
import NVIncidentReport from "../views/Reports/NVIncidents.vue"
import MARReport from "../views/Reports/MARReport.vue"
import HABReport from "../views/Reports/HABReport.vue"
import Investigations from "../views/client/Investigation.vue"
import InvestigationForm from "../views/client/Reporting/InvestigationForm.vue"
import InvestigationLogs from "../views/client/InvestigationLogs.vue"
import StaffCommunication from "../views/StaffCommunication.vue"
import StaffCommunicationForm from "../views/StaffCommunication/form.vue"
import LocationReport from "../views/Reports/Locations.vue"
import ClientSummary from "../views/client/ClientSummary.vue"
import InserviceTrainingReport from "../views/Reports/InserviceTraining.vue"
import MissedTrainingReport from "../views/Reports/MissedTraining.vue"
import TrainingHistoryReport from "../views/Reports/TrainingHistory.vue"
import FireDrills from "../views/GlobalFireDrills.vue"
import HouseMaintenance from "../views/HouseMaintenance.vue"
import BulkAttendance from "../views/Reports/BulkAttendance.vue"
import MedChange from "../views/client/MedChange.vue"
import MedicationChangeForm from "../views/client/Medication/MedicationChangeForm.vue"
import ClientList from "../views/Reports/Client.vue"
import StaffList from "../views/Reports/Staff.vue"
import TimeOffRequests from "../views/Reports/TimeOff.vue"
import UserNotifications from "../views/UserNotifications.vue"
import EmergencyContact from "../views/staff/EmergencyContact"
import AdaptiveEquipment from "../views/client/Adaptive.vue"
import AdaptiveEquipmentForm from "../views/client/OnBoardInfo/AdaptiveEquipmentForm.vue"
import JobOpportunity from "../views/JobOpportunities.vue"
import VehicleInspectionReport from "../views/Reports/VehicleReport.vue"
import OffSiteVisit from "../views/client/OffSite.vue"
import OffSiteVisitForm from "../views/client/Reporting/OffSiteVisitForm.vue"
import AllADL from "../views/Reports/AllADL.vue"
import BowelMovementCharting from "../views/client/BowelMovementCharting"
import BMChart from "../views/client/BowelMovementCharting/chart"
import ClientDischarge from "../views/client/Checklists/Discharge.vue"
import ClientDischargeForm from "../views/client/OnBoardInfo/ClientDischargeForm.vue"
import ClientMove from "../views/client/Checklists/ClientMove.vue"
import ClientMoveForm from "../views/client/OnBoardInfo/ClientMoveForm.vue"
import Timesheet from "../views/Timesheet.vue"
import Company from "../views/Company.vue"
import Vehicles from "../views/Vehicles.vue"
import VehicleMaintenance from "../views/VehicleMaintenance/index.vue"
import VehicleMaintenanceReport from "../views/Reports/VehicleMaintenanceReport.vue"
import StaffInventory from "../views/StaffInventory.vue"
import StaffInventoryReport from "../views/Reports/StaffInventory.vue"
import ClientInventoryReport from "../views/Reports/ClientInventory.vue"
import FluidTrackingCharting from "../views/client/FluidTracking"
import FTChart from "../views/client/FluidTracking/chart"
import ResidentialLog from "../views/ResidentialLog.vue"
import NevadaInvoice from "../views/NevadaInvoice.vue"
import NevadaBillingReport from "../views/Reports/NevadaBilling.vue"
import CaseManagement from "../views/client/CaseManagement.vue"
import Ancillary from "../views/client/Ancillary.vue"
import CaseManagementReport from "../views/Reports/CaseManagement.vue"
import AncillaryReport from "../views/Reports/Ancillary.vue"
import ServiceLog from "../views/client/ServiceLog.vue"
import Garnishments from "../views/staff/Garnishments"
import Performance from "../views/Reports/Performance"
import Billing from "../views/Reports/Billing"
import Programs from "../views/Reports/Programs"
import ResidentialServiceLog from "../views/Reports/ResidentialServiceLog"
import MissingClock from "../views/Reports/ClockIn"
import MissingClockOut from "../views/Reports/ClockOut"
import Transportation from "../views/client/Transportation"
import ProgramDashboard from "../views/ProgramDashboard"
import ProgramDocuments from "../views/ProgramDocumentsPage.vue"
import ProgramMaintenance from "../views/ProgramMaintenance.vue"
import ProgramInventory from "../views/ProgramInventory.vue"
import ProgramFireDrill from "../views/ProgramFireDrills.vue"


import MedicationControlledSubstance from "../views/client/MedicationControlledSubstance"
import ClientAttendanceReport from "../views/Reports/ClientAttendance.vue"
import AdjustmentsNew from "../views/Adjustments/index.vue"
import InserviceTrainingNew from "../views/InserviceTraining/index.vue"
import JDTAttendanceLogReport from "../views/Reports/JDTAttendanceLogs.vue"


// sample new hire portal page
import NewHirePortalNew from "../views/new_hire_portal_new"

//New page for Date Tracking Sheets
import JDTProgressReport from "../views/data_tracking_sheets/JDTProgressReport"
import RSSLog24 from "../views/data_tracking_sheets/RSSLog24"
import SLAProgressReport from "../views/data_tracking_sheets/SLAProgressReport"
import JDTAttendanceLogs from "../views/data_tracking_sheets/JDTAttendanceLogs"
import RSSInterminateSupportLogs from "../views/data_tracking_sheets/RSSInterminateSupportLogs"
import SupplmentalResidentialSupport from "../views/data_tracking_sheets/SupplmentalResidentialSupport"

// Compensations/Deductions
import HealthCare from "../views/staff/HealthCare"
import Incentives from "../views/staff/Incentives"
import Bonus from "../views/staff/Bonus"
import Raise from "../views/staff/Raises"

import StaffShiftReports from "../views/Reports/StaffShiftReports.vue"

import RolesPermission from "../views/RolesPermission.vue"


import Roles from "../views/Roles.vue"


import PrivacyPage from '../views/PrivacyPolicy.vue'
import TermsOfService from '../views/TermsOfService.vue'

import {parseJwt} from "../../utils/parseJwt";

import { STAFF_ROLES } from '../enums/RolesEnum';

//MOVE ROUTES TO CHILD ROUTES

Vue.use(VueRouter)

const routes = [
    {
        path: '/sharing/:path',
        name: 'Shared',
        component: Shared,
    },
    {
        path: '/LinkNotFound',
        name: 'LinkError',
        component: LinkError,
    },
    {
        path: '/',
        name: 'Login',
        component: Login,
        beforeEnter: (to, from, next) => {
            let token = localStorage.getItem('token')
            let userId = localStorage.getItem("userID")
            if (token) {
                const jwtPayload = parseJwt(token);
                if (jwtPayload.exp < Date.now() / 1000) {
                    console.log('Token Expired')
                    localStorage.removeItem("token")
                    next("/");
                }
                next('/staffInfo/' + userId);
            } else {
                next();
            }
        }
    },
    {
        path: "",
        component: () => import("@/views/dashboard/Index"),
        name: "Dashboard1",
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem("token")) {
                next();
            } else {
                next("/secure");
            }
        },
        children: [
            // {
            //   path: '/dashboard',
            //   name: 'Dashboard',
            //   component: Dashboard,
            //   beforeEnter: (to, from, next) => {
            //     if(localStorage.getItem('token')){
            //       next();
            //     }else{
            //       next('/');
            //     }
            //   }
            // },
            {
                path: '/Employees',
                name: 'Employees',
                component: Employees,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                },
                children: []
            },
            {
                path: '/Client',
                name: 'Client',
                component: Client,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Pharmacy"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"

                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Unit',
                name: 'Unit',
                component: Unit,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/ClientInfo/:clientID',
                name: 'ClientInfo',
                component: ClientInfo,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Pharmacy"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/StaffInfo/:employeeID',
                name: 'StaffInfo',
                component: StaffInfo,
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/shifts/add-shift',
                name: 'ShiftsAdd',
                component: ShiftsForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
              path: '/shifts/update-shift',
              name: 'ShiftsUpdate',
              component: ShiftsFormUpdate,
              beforeEnter: (to, from, next) =>
              {
                if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                  || localStorage.getItem('userRole') == "House Manager"
                  || localStorage.getItem('userRole') == "Regional Director"
                  || localStorage.getItem('userRole') == "Program Manager"
                  || localStorage.getItem('userRole') == "Human Resources"
                  || localStorage.getItem('userRole') == "Client Services Manager"
                  || localStorage.getItem('userRole') == "Program Coordinator"
                  || localStorage.getItem('userRole') == "Medical Manager"
                  || localStorage.getItem('userRole') == "Executive Director"
                  || localStorage.getItem('userRole') == "Compliance Manager"
                  || localStorage.getItem('userRole') == "Finance Manager"
                  || localStorage.getItem('userRole') == "SuperAdministrator"
                  || localStorage.getItem('userRole') == "Direct Care Staff"
                  || localStorage.getItem('userRole') == "Assistant Manager"
                  || localStorage.getItem('userRole') == "Shift Lead"
                  || localStorage.getItem('userRole') == "Human Resources Assistant"
                )
                {
                  next();
                } else
                {
                  next('/secure');
                }
              }
            },
            {
                path: '/Shifts',
                name: 'Shifts',
                component: Shifts,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
              path: '/ClockInTracker',
              name: 'ClockInTracker',
              component: ClockInTracker,
              beforeEnter: (to, from, next) => {
                  if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                      || localStorage.getItem('userRole') === "Direct Care Staff"
                      || localStorage.getItem('userRole') == "Regional Director"
                      || localStorage.getItem('userRole') === "Shift Lead"
                      || localStorage.getItem('userRole') === "Shift Lead"
                      || localStorage.getItem('userRole') === "Assistant Manager"
                      || localStorage.getItem('userRole') === "House Manager"
                      || localStorage.getItem('userRole') === "Program Manager"
                      || localStorage.getItem('userRole') === "Human Resources"
                      || localStorage.getItem('userRole') === "Client Services Manager"
                      || localStorage.getItem('userRole') === "Program Coordinator"
                      || localStorage.getItem('userRole') === "Medical Manager"
                      || localStorage.getItem('userRole') === "Executive Director"
                      || localStorage.getItem('userRole') === "Compliance Manager"
                      || localStorage.getItem('userRole') === "Finance Manager"
                      || localStorage.getItem('userRole') === "SuperAdministrator"
                      || localStorage.getItem('userRole') == "Human Resources Assistant"
                  ) {
                      next();
                  } else {
                      next('/secure');
                  }
              }

          },
            {
                path: '/UserAuthLog',
                name: 'UserAuthLog',
                component: UserAuthLog,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Users',
                name: 'Users',
                component: Users,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/users/add-user',
                name: 'Add User Form',
                component: UserForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/users/update-user/:id',
                name: 'Update User Form',
                component: UserForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/usersRoles',
                name: 'Users Roles',
                component: UsersRoles,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/userProfile',
                name: 'UserProfile',
                component: UserProfile,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/medications/:clientID',
                name: 'Medications',
                component: Medications,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Pharmacy"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/medications/:clientID/add-medication',
                name: 'Add Medication',
                component: MedicationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "Pharmacy"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/medications/:clientID/update-medication/:id',
                name: 'Update Medication',
                component: MedicationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "Pharmacy"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/mar/:clientID/:page',
                name: 'MAR',
                component: MAR,
                children: [
                    {
                        path: ':sharing',
                    }
                ],
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                },
            },
            {
                path: '/Codes',
                name: 'Codes',
                component: Codes,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Certifications/:employeeID',
                name: 'Certs',
                component: Certs,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Certifications/:employeeID/:action(add|edit|view)/:id?',
                name: 'Certification Form',
                component: () => import("@/views/certifications/CertificationForm"),
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/adl/:clientID',
                name: 'ADL',
                component: ADL,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/servicePlan/:clientID',
                name: 'ServicePlan',
                component: ServicePlan,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
              path: "/servicePlan/:clientID/add",
              name: "Add Service",
              component: () => import("@/views/client/ServicePlan/ServiceForm"),
              props: { mode: "add" },
              beforeEnter: (to, from, next) => {
                if (
                  (localStorage.getItem("token") &&
                    localStorage.getItem("userRole") == "Administration") ||
                  localStorage.getItem("userRole") == "Direct Care Staff" ||
                  localStorage.getItem("userRole") == "Regional Director" ||
                  localStorage.getItem("userRole") == "Shift Lead" ||
                  localStorage.getItem("userRole") == "Assistant Manager" ||
                  localStorage.getItem("userRole") == "House Manager" ||
                  localStorage.getItem("userRole") == "Program Manager" ||
                  localStorage.getItem("userRole") == "Human Resources" ||
                  localStorage.getItem("userRole") == "Client Services Manager" ||
                  localStorage.getItem("userRole") == "Program Coordinator" ||
                  localStorage.getItem("userRole") == "Medical Manager" ||
                  localStorage.getItem("userRole") == "Executive Director" ||
                  localStorage.getItem("userRole") == "Compliance Manager" ||
                  localStorage.getItem("userRole") == "Finance Manager" ||
                  localStorage.getItem("userRole") == "SuperAdministrator" ||
                  localStorage.getItem("userRole") == "Human Resources Assistant"||
                  localStorage.getItem('userRole') == "Auditor"

                ) {
                  next();
                } else {
                  next("/secure");
                }
              },
            },
            {
              path: "/servicePlan/:clientID/edit",
              name: "Update Service",
              component: () => import("@/views/client/ServicePlan/ServiceForm"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  (localStorage.getItem("token") &&
                    localStorage.getItem("userRole") == "Administration") ||
                  localStorage.getItem("userRole") == "Direct Care Staff" ||
                  localStorage.getItem("userRole") == "Regional Director" ||
                  localStorage.getItem("userRole") == "Shift Lead" ||
                  localStorage.getItem("userRole") == "Assistant Manager" ||
                  localStorage.getItem("userRole") == "House Manager" ||
                  localStorage.getItem("userRole") == "Program Manager" ||
                  localStorage.getItem("userRole") == "Human Resources" ||
                  localStorage.getItem("userRole") == "Client Services Manager" ||
                  localStorage.getItem("userRole") == "Program Coordinator" ||
                  localStorage.getItem("userRole") == "Medical Manager" ||
                  localStorage.getItem("userRole") == "Executive Director" ||
                  localStorage.getItem("userRole") == "Compliance Manager" ||
                  localStorage.getItem("userRole") == "Finance Manager" ||
                  localStorage.getItem("userRole") == "SuperAdministrator" ||
                  localStorage.getItem("userRole") == "Human Resources Assistant" ||
                  localStorage.getItem('userRole') == "Auditor"
                ) {
                  next();
                } else {
                  next("/secure");
                }
              },
            },
            {
                path: '/support/:clientID',
                name: 'Support',
                component: Support,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/support/:clientID/:action(add|edit|view)',
                name: 'Support Form',
                component: () => import("@/views/client/Support/SupportForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Regional Director",
                        "Shift Lead",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/attendance/:clientID',
                name: 'Attendance',
                component: Attendance,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "Regional Director",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/attendance/:clientID/new',
                name: 'Add Attendance',
                component: AttendanceForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "Regional Director",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/attendance/:clientID/update/:id',
                name: 'Update Attendance',
                component: AttendanceForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "Regional Director",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/providers/:clientID',
                name: 'Providers',
                component: Providers,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/providers/:clientID/new',
                name: 'Add Providers',
                component: ProviderForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/providers/:clientID/update/:id',
                name: 'Update Providers',
                component: ProviderForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/incidents/:clientID',
                name: 'Incidents',
                component: Incidents,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/incidents/:clientID/add-incident',
                name: 'Add Incident Form',
                component: IncidentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/incidents/:clientID/update-incident/:id',
                name: 'Update Incident Form',
                component: IncidentForm,
                props: true,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/incidents/view-incident/:id',
                name: 'View Incident Form',
                component: IncidentForm,
                props: true,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/rights/:clientID',
                name: 'Rights',
                component: Rights,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/rights/:clientID/new',
                name: 'Add Human Rights Restriction',
                component: HumanRightsRestrictionForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/rights/:clientID/update/:id',
                name: 'Update Human Rights Restriction',
                component: HumanRightsRestrictionForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/inventory/:clientID',
                name: 'Inventory',
                component: Inventory,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Compliance Manager",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/inventory/:clientID/new',
                name: 'Add Inventory Form',
                component: InventoryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Compliance Manager",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: `/inventory/:clientID/update/:id`,
                name: 'Update Inventory Form',
                component: InventoryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Compliance Manager",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/events/:clientID',
                name: 'Events',
                component: Events,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/events/:clientID/add-event',
                name: 'Add Events',
                component: EventForm,
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/events/:clientID/update-event/:id',
                name: 'Update Events',
                component: EventForm,
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/diagnoses/:clientID',
                name: 'Diagnoses',
                component: Diagnoses,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/diagnoses/:clientID/new',
                name: 'Add Diagnosis',
                component: DiagnosisForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/diagnoses/:clientID/update/:id',
                name: 'Update Diagnosis',
                component: DiagnosisForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/finances/:clientID',
                name: 'Finances',
                component: Finances,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/finances/:clientID/new',
                name: 'Add Finances',
                component: FinancesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/finances/:clientID/update/:id',
                name: 'Update Finances',
                component: FinancesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/finance-transactions/:clientID?',
                name: 'Transaction History',
                component: FinanceTransactions,
                props: true,
                beforeEnter: (to, from, next) => {
                    const { financeID, type } = to.query;

                    if (!financeID || !type) {
                        next('/LinkNotFound');
                    }else{
                        if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                            || localStorage.getItem('userRole') == "Assistant Manager"
                            || localStorage.getItem('userRole') == "Regional Director"
                            || localStorage.getItem('userRole') == "House Manager"
                            || localStorage.getItem('userRole') == "Program Manager"
                            || localStorage.getItem('userRole') == "Human Resources"
                            || localStorage.getItem('userRole') == "Client Services Manager"
                            || localStorage.getItem('userRole') == "Program Coordinator"
                            || localStorage.getItem('userRole') == "Medical Manager"
                            || localStorage.getItem('userRole') == "Executive Director"
                            || localStorage.getItem('userRole') == "Compliance Manager"
                            || localStorage.getItem('userRole') == "Client"
                            || localStorage.getItem('userRole') == "Finance Manager"
                            || localStorage.getItem('userRole') == "SuperAdministrator"
                            || localStorage.getItem('userRole') == "Human Resources Assistant"
                            || localStorage.getItem('userRole') == "Auditor"
                        ) {
                            next();
                        } else {
                            next('/secure');
                        }
                    }
                }
            },
            {
                path: '/assessments/:clientID',
                name: 'Assessments',
                component: Assessments,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/assessments/:clientID/new',
                name: 'New Assessment',
                component: AssessmentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/assessments/:clientID/update/:id',
                name: 'Update Assessment',
                component: AssessmentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/annualDocs/:clientID',
                name: 'AnnualDocs',
                component: AnnualDocs,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/annualDocs/:clientID/new',
                name: 'Add Annual Document',
                component: AnnualDocumentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/annualDocs/:clientID/update/:id',
                name: 'Update Annual Document',
                component: AnnualDocumentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/Reimbursements/:employeeID',
                name: 'Reimbursements',
                component: Reimbursements,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            /*{
                path: '/Adjustments/:employeeID',
                name: 'Adjustments',
                component: Adjustments,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },*/
            {
                path: '/Adjustments/:employeeID',
                name: 'Adjustments',
                component: AdjustmentsNew,
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Regional Director",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Adjustments/:employeeID/:action(add|edit|view)/:id?',
                name: 'Adjustment Form',
                component: () => import("@/views/Adjustments/AdjustmentForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Regional Director",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/WorkersComp/:employeeID',
                name: 'WorkersComp',
                component: WorkersComp,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/workers-comp/:employeeID/:action(add|edit|view)',
                name: 'Workers Comp Form',
                component: () => import("@/views/staff/WorkersComp/WorkerCompForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            /*{
                path: '/InserviceTraining/:employeeID',
                name: 'InserviceTraining',
                component: InserviceTraining,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },*/
            {
                path: '/InserviceTraining/:employeeID',
                name: 'InserviceTraining',
                component: InserviceTrainingNew,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/InserviceTraining/:employeeID/:action(add|edit|view)/:id?',
                name: 'Inservice Training Form',
                component: () => import("@/views/InserviceTraining/TrainingForm"),
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/staffCertification',
                name: 'staffCertification',
                component: staffCertification,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/contactInfo/:clientID',
                name: 'ContactInfo',
                component: ContactInfo,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/contactInfo/:clientID/new',
                name: 'Add Contact Info',
                component: ContactInfoForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/contactInfo/:clientID/update/:id',
                name: 'Update Contact Info',
                component: ContactInfoForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Notifications',
                name: 'Notifications',
                component: Notifications,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Reports',
                name: 'Reports',
                component: Reports,
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');

                    const allowedRoles = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant"
                    ];

                    if (token && allowedRoles.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/ClientTest/:employeeID',
                name: 'ClientTest',
                component: ClientTest,
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const allowedRoles = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && allowedRoles.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/ClientTest/:employeeID/:action(add|edit|view)',
                name: 'Client Test Form',
                component: () => import("@/views/staff/ClientTests/ClientTestsForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/medVisit/:clientID',
                name: 'MedVisit',
                component: MedVisit,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/medVisit/:clientID/update-visit/:id',
                name: 'Update Visit',
                component: VisitForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/medVisit/:clientID/view-visit/:id',
                name: 'View Medical Visit',
                component: VisitForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/weeklySummary/:clientID',
                name: 'WeeklySummary',
                component: WeeklySummary,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/weeklySummary/:clientID/new',
                name: 'Add Weekly Summary',
                component: WeeklySummaryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/weeklySummary/:clientID/update/:id',
                name: 'Update Weekly SUmmary',
                component: WeeklySummaryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviorReport/:clientID',
                name: 'BehaviorReport',
                component: BehaviorReport,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviorReport/:clientID/new',
                name: 'Add Behavior Report',
                component: BehaviorReportForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviorReport/:clientID/update/:id',
                name: 'Update Behavior Report',
                component: BehaviorReportForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Client",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/NewHirePortal/:empID',
                name: 'NewHirePortal',
                component: NewHirePortalNew,
                alias: '/NewHirePortal',
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/NewHirePortal1',
                name: 'NewHirePortal1',
                component: NewHirePortal,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            // {
            //   path: '/NewHirePortalNew/:empID',
            //   name: 'New Hire Portal New',
            //   component: NewHirePortalNew,
            //   alias: '/NewHirePortalNew',
            //   props: true,
            //   beforeEnter: (to, from, next) => {
            //     if(localStorage.getItem('token')){
            //       next();
            //     }else{
            //       next('/secure');
            //     }
            //   }
            // },
            {
                path: '/Calendar',
                name: 'Calendar',
                component: Calendar,
                children: [
                    {
                        path: 'view/:id',
                    },
                ],
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Consents',
                name: 'Consents',
                component: Consents,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Training',
                name: 'Training',
                component: Training,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/training-history',
                name: 'Training History',
                component: TrainingHistory,
                beforeEnter: (to, from, next) => {
                  if (
                    localStorage.getItem('token') &&
                    (
                      localStorage.getItem('userRole') == "Administration" ||
                      localStorage.getItem('userRole') == "Direct Care Staff" ||
                      localStorage.getItem('userRole') == "Regional Director" ||
                      localStorage.getItem('userRole') == "Shift Lead" ||
                      localStorage.getItem('userRole') == "Assistant Manager" ||
                      localStorage.getItem('userRole') == "House Manager" ||
                      localStorage.getItem('userRole') == "Program Manager" ||
                      localStorage.getItem('userRole') == "Human Resources" ||
                      localStorage.getItem('userRole') == "Client Services Manager" ||
                      localStorage.getItem('userRole') == "Program Coordinator" ||
                      localStorage.getItem('userRole') == "Medical Manager" ||
                      localStorage.getItem('userRole') == "Executive Director" ||
                      localStorage.getItem('userRole') == "Compliance Manager" ||
                      localStorage.getItem('userRole') == "Finance Manager" ||
                      localStorage.getItem('userRole') == "SuperAdministrator" ||
                      localStorage.getItem('userRole') == "Human Resources Assistant" ||
                      localStorage.getItem('userRole') == "Auditor"
                    )
                  ) {
                    next();
                  } else {
                    next('/secure');
                  }
                }
              },
            {
                path: '/DocumentLibrary/:employeeID',
                name: 'DocumentLibrary',
                component: DocumentLibrary,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/documentLibraryClient/:clientID',
                name: 'DocumentLibraryClient',
                component: DocumentLibraryClient,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/serviceCodes/:clientID',
                name: 'ServiceCodes',
                component: ServiceCodes,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/serviceCodes/:clientID/new',
                name: 'Add Service Code',
                component: ServiceCodesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/serviceCodes/:clientID/update/:id',
                name: 'Update Service Code',
                component: ServiceCodesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/monthlySummaries/:clientID',
                name: 'MonthlySummaries',
                component: MonthlySummaries,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/monthlySummaries/:clientID/new',
                name: 'Add Monthly Summary',
                component: MonthlySummaryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/monthlySummaries/:clientID/update/:id',
                name: 'Update Monthly Summary',
                component: MonthlySummaryForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/monthlySummaries/:clientID',
                name: 'QuarterlySummaries',
                component: QuarterlySummaries,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Survey',
                name: 'Survey',
                component: Survey,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Test',
                name: 'Test',
                component: Test,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviors/:clientID',
                name: 'Behaviors',
                component: Behaviors,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviors/:clientID/new',
                name: 'Add Behavior',
                component: BehaviorForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/behaviors/:clientID/update/:id',
                name: 'Update Behavior',
                component: BehaviorForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Tasks',
                name: 'Tasks',
                component: Tasks,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Chat',
                name: 'Chat',
                component: Chat,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {

                path: '/medicationInventory/:clientID',
                name: 'MedicationInventory',
                component: MedicationInventory,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Pharmacy"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') ===  "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {

                path: '/medicationInventory/:clientID/add',
                name: 'Add Medication Inventory Form',
                component: MedicationInventoryForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "Pharmacy"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                        || localStorage.getItem('userRole') === "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {

                path: '/medicationInventory/:clientID/update/:id',
                name: 'Update Medication Inventory Form',
                component: MedicationInventoryForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "Pharmacy"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                        || localStorage.getItem('userRole') === "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/allergies/:clientID',
                name: 'Allergies',
                component: Allergies,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/allergies/:clientID/new',
                name: 'Add Allergies',
                component: AllergiesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/allergies/:clientID/update/:id',
                name: 'Update Allergies',
                component: AllergiesForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            // {
            //   path: '/Zoom',
            //   name: 'Zoom',
            //   component: Zoom,
            //   beforeEnter: (to, from, next) => {
            //     if(localStorage.getItem('token')){
            //       next();
            //     }else{
            //       next('/');
            //     }
            //   }
            // },
            {
                path: '/GlobalTraining',
                name: 'GlobalTraining',
                component: GlobalTraining,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/NHO',
                name: 'NHO',
                component: NHO,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/warning/:clientID',
                name: 'Warning',
                component: Warning,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/warning/:clientID/new',
                name: 'Add Warning',
                component: WarningForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/warning/:clientID/update/:id',
                name: 'Update Warning',
                component: WarningForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Secure',
                name: 'Secure',
                component: Secure,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/');
                    }
                }
            },
            {
                path: '/PerformanceReview',
                name: 'Performance Review',
                component: PerformanceReview,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/Review',
                name: 'Review',
                component: Review,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/rad/:clientID',
                name: 'RAD',
                component: RAD,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/dor/:clientID',
                name: 'DOR',
                component: DOR,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/fireDrill/:clientID',
                name: 'FireDrill',
                component: FireDrill,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/fireDrill/:clientID/new',
                name: 'Add FireDrill',
                component: FireDrillForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/fireDrill/:clientID/update/:id',
                name: 'Update FireDrill',
                component: FireDrillForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/fireDrill',
                name: 'FireDrills',
                component: FireDrills,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/MonthlyChecklist',
                name: 'MonthlyChecklist',
                component: MonthlyChecklist,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/Mileage/:employeeID',
                name: 'Mileage',
                component: Mileage,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/IncidentReport',
                name: 'IncidentReport',
                component: IncidentReport,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/IncidentReportGraph',
                name: 'IncidentReportGraphNew',
                component: IncidentReportGraphNew,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/UpcomingEventsReport',
                name: 'UpcomingEventsReport',
                component: UpcomingEventsReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/MedicalVisitsReport',
                name: 'MedicalVisitsReport',
                component: MedicalVisitsReport,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/AttendanceReport',
                name: 'AttendanceReport',
                component: AttendanceReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/ReportingBehaviors',
                name: 'ReportingBehaviors',
                component: ReportingBehaviors,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/ADLReport',
                name: 'ADLReport',
                component: ADLReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/UnsignedADLReport',
                name: 'UnsignedADLReport',
                component: UnsignedADLReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/FinancesReport',
                name: 'FinancesReport',
                component: FinancesReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/ExpiringDocuments',
                name: 'ExpiringDocuments',
                component: ExpiringDocuments,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/CompTests',
                name: 'CompTests',
                component: CompTests,
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Regional Director",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "House Manager"

                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/compTests/view/:id',
                name: 'ViewCompTests',
                component: ClientCompetencyTestForm,
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Regional Director",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "House Manager"

                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/MissingCertifications',
                name: 'MissingCertifications',
                component: MissingCertifications,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/StaffExpiring',
                name: 'StaffExpiring',
                component: StaffExpiring,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/viewStaffCertification/:id',
                name: 'Staff Certification',
                component: CertificationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/StaffExpenses',
                name: 'StaffExpenses',
                component: StaffExpenses,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/staffExpenses/view/:id',
                name: 'View Staff Reimbursement',
                component: StaffReimbursementForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/MonthlyFire',
                name: 'MonthlyFire',
                component: MonthlyFire,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/MARVerified',
                name: 'MARVerified',
                component: MARVerified,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/medication-report',
                name: 'Medication Report',
                component: MedicationReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
              path: '/EVVReport',
              name: 'EVVReport',
              component: EVVReport,
              beforeEnter: (to, from, next) => {
                  if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                      || localStorage.getItem('userRole') == "Program Manager"
                      || localStorage.getItem('userRole') == "Regional Director"
                      || localStorage.getItem('userRole') == "Human Resources"
                      || localStorage.getItem('userRole') == "Client Services Manager"
                      || localStorage.getItem('userRole') == "Program Coordinator"
                      || localStorage.getItem('userRole') == "Medical Manager"
                      || localStorage.getItem('userRole') == "Executive Director"
                      || localStorage.getItem('userRole') == "Compliance Manager"
                      || localStorage.getItem('userRole') == "Finance Manager"
                      || localStorage.getItem('userRole') == "SuperAdministrator"
                      || localStorage.getItem('userRole') == "Human Resources Assistant"
                  ) {
                      next();
                  } else {
                      next('/secure');
                  }
              }
          },

            {
                path: '/medHandOff/:clientID',
                name: 'MedHandOff',
                component: MedHandOff,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/medHandOff/:clientID/:action(add|edit|view)',
                name: 'Medhandoff Form',
                component: () => import("@/views/client/Medication/MedHandOff/MedHandOffForm"),
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/EmployeeEvaluation',
                name: 'EmployeeEvaluation',
                component: EmployeeEvaluation,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/TimeOff/:employeeID',
                name: 'TimeOff',
                component: TimeOff,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/timeOff/:employeeID/add-time-off-request',
                name: 'Add Time Off Request',
                component: AddTimeOffRequest,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/timeOff/:employeeID/update-time-off-request/:timeOffRequestID',
                name: 'Update Time Off Request',
                component: UpdateTimeOffRequest,
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') === "Administration"
                        || localStorage.getItem('userRole') === "Program Manager"
                        || localStorage.getItem('userRole') === "Regional Director"
                        || localStorage.getItem('userRole') === "Human Resources"
                        || localStorage.getItem('userRole') === "Client Services Manager"
                        || localStorage.getItem('userRole') === "Program Coordinator"
                        || localStorage.getItem('userRole') === "Medical Manager"
                        || localStorage.getItem('userRole') === "Executive Director"
                        || localStorage.getItem('userRole') === "Compliance Manager"
                        || localStorage.getItem('userRole') === "Finance Manager"
                        || localStorage.getItem('userRole') === "Direct Care Staff"
                        || localStorage.getItem('userRole') === "Shift Lead"
                        || localStorage.getItem('userRole') === "Assistant Manager"
                        || localStorage.getItem('userRole') === "House Manager"
                        || localStorage.getItem('userRole') === "SuperAdministrator"
                        || localStorage.getItem('userRole') === "Human Resources Assistant"
                        || localStorage.getItem('userRole') === "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/Payroll',
                name: 'Payroll',
                component: Payroll,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/nvIncidents/:clientID',
                name: 'NVIncidents',
                component: NVIncidents,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/nvIncidents/:clientID/add-incident',
                name: 'NV Add Incident',
                component: NVIncidentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/nvIncidents/:clientID/update-incident/:id',
                name: 'NV Update Incident Form',
                component: NVIncidentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/nvIncidents/view-incident/:id',
                name: 'NV View Incident',
                component: NVIncidentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },


            {
                path: '/hab/:clientID',
                name: 'HAB',
                component: HAB,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/habChart/:clientID',
                name: 'HABChart',
                component: HABChart,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/dataTracking/:clientID',
                name: 'DataTracking',
                component: DataTracking,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/meals/:clientID',
                name: 'Meals',
                component: Meals,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Regional Director",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/meals/:clientID/new',
                name: 'Add Meal',
                component: MealsForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Regional Director",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/meals/:clientID/update/:id',
                name: 'Update Meals',
                component: MealsForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Regional Director",
                        "Human Resources Assistant",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/communication/:clientID/:action(add|edit|view)/:communicationID?',
                name: 'CommunicationForm',
                component: CommunicationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/communication/:clientID',
                name: 'Communication',
                component: Communication,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/staffCommunication/:employeeID/:action(add|edit|view)/:communicationID?',
                name: 'StaffCommunicationForm',
                component: StaffCommunicationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                },
            },
            {
                path: '/staffCommunication/:employeeID',
                name: 'StaffCommunication',
                component: StaffCommunication,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/mileage-transactions/:mileageID',
                name: 'Mileage History',
                component: MileageTransactions,
                props: true,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: 'GlobalProvider',
                name: 'GlobalProvider',
                component: GlobalProvider,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: 'VehicleInspection/:employeeID',
                name: 'Vehicle Inspection',
                component: VehicleInspection,
                beforeEnter: (to, from, next) => {

                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/VehicleInspection/:employeeID/:action(add|edit|view)',
                name: 'Vehicle Inspection Form',
                component: () => import("@/views/staff/VehicleInspection/VehicleInspectionForm"),
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: 'HRCReport/:clientID/:rightID',
                name: 'HRC Report',
                component: HRCReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: 'HouseMaintenance',
                name: 'House Repair Form',
                component: HouseRepair,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"

                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/NVIncidentReport',
                name: 'NVIncidentReport',
                component: NVIncidentReport,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/MARReport',
                name: 'MAR Report',
                component: MARReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/HABReport',
                name: 'HAB Report',
                component: HABReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Investigations/:clientID',
                name: 'Investigations',
                component: Investigations,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')

                    && localStorage.getItem('userRole')=="Administration"
                    || localStorage.getItem('userRole') == "Human Resources"
                    || localStorage.getItem('userRole') == "Human Resources Assistant"
                    || localStorage.getItem('userRole') == "Client Services Manager"
                    || localStorage.getItem('userRole') == "Program Coordinator"
                    || localStorage.getItem('userRole') == "Executive Director"
                    || localStorage.getItem('userRole') == "Compliance Manager"
                    || localStorage.getItem('userRole') == "Finance Manager"
                    || localStorage.getItem('userRole') == "Auditor"

                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/investigations/:clientID/new',
                name: 'Add Investigation',
                component: InvestigationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/investigations/:clientID/update/:id',
                name: 'Update Investigation',
                component: InvestigationForm,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token')) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/InvestigationLogs/:clientID?',
                name: 'Investigation Logs',
                component: InvestigationLogs,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Locations',
                name: 'Locations',
                component: LocationReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientSummary/:clientID',
                name: 'Client Summary',
                component: ClientSummary,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/InserviceTrainingReport',
                name: 'Inservice Training Report',
                component: InserviceTrainingReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
          {
            path: '/reports/missedTraining',
            name: 'Missed Training Report',
            component: MissedTrainingReport,
            beforeEnter: (to, from, next) => {
              const USER_ROLE = [
                "Administration",
                "Assistant Manager",
                "House Manager",
                "Program Manager",
                "Human Resources",
                "Human Resources Assistant",
                "Client Services Manager",
                "Program Coordinator",
                "Medical Manager",
                "Executive Director",
                "Compliance Manager",
                "Finance Manager",
                "Direct Care Staff",
                "Regional Director",
                "Shift Lead",
                "SuperAdministrator",
                "Client",
                "Auditor"
              ];

              if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                next();
              } else {
                next('/secure');
              }
            }
          },
          {
            path: '/reports/training-history',
            name: 'Training History Report',
            component: TrainingHistoryReport,
            beforeEnter: (to, from, next) => {
              const USER_ROLE = [
                "Administration",
                "Assistant Manager",
                "House Manager",
                "Program Manager",
                "Human Resources",
                "Human Resources Assistant",
                "Client Services Manager",
                "Program Coordinator",
                "Medical Manager",
                "Executive Director",
                "Compliance Manager",
                "Finance Manager",
                "Direct Care Staff",
                "Regional Director",
                "Shift Lead",
                "SuperAdministrator",
                "Client",
                "Auditor"
              ];

              if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                next();
              } else {
                next('/secure');
              }
            }
          },
            {
                path: '/HouseMaintenance',
                name: 'Maintenance Form',
                component: HouseMaintenance,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/BulkAttendance',
                name: 'Bulk Attendance',
                component: BulkAttendance,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"

                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/MedChange/:clientID',
                name: 'Medication Change',
                component: MedChange,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/medChange/:clientID/:action(add|edit|view)',
                name: 'Med Change Form',
                component: MedicationChangeForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/ClientList',
                name: 'Client List',
                component: ClientList,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/StaffList',
                name: 'Staff List',
                component: StaffList,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/TimeOffRequests',
                name: 'Time Off Requests',
                component: TimeOffRequests,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/UserNotifications/:employeeID',
                name: 'UserNotifications',
                component: UserNotifications,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/EmergencyContact/:employeeID',
                name: 'EmergencyContact',
                component: EmergencyContact,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/emergency-contact/:employeeID/:action(add|edit|view)',
                name: 'Contact Form',
                component: () => import("@/views/staff/EmergencyContact/EmergencyContactForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                       "Administration",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Shift Lead",
                        "Direct Care Staff",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "SuperAdministrator",
                        "Regional Director",
                        "Human Resources Assistant",
                        "Compliance Manager",
                        "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/equipment/:clientID',
                name: 'Adaptive Equipment',
                component: AdaptiveEquipment,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/equipment/:clientID/new',
                name: 'Add Adaptive Equipment',
                component: AdaptiveEquipmentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/equipment/:clientID/update/:id',
                name: 'Update Adaptive Equipment',
                component: AdaptiveEquipmentForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/jobs',
                name: 'Job Opportunity',
                component: JobOpportunity,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/vehicleReport',
                name: 'Vehicle Inspection Report',
                component: VehicleInspectionReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/offSiteVisit/:clientID',
                name: 'OffSiteVisit',
                component: OffSiteVisit,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "House Manager",
                        "Assistant Manager",
                        "Shift Lead",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Regional Director",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/offSiteVisit/:clientID/new',
                name: 'Add Off Site Visit',
                component: OffSiteVisitForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "House Manager",
                        "Assistant Manager",
                        "Shift Lead",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Regional Director",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/offSiteVisit/:clientID/update/:id',
                name: 'Update Off Site Visit',
                component: OffSiteVisitForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "House Manager",
                        "Assistant Manager",
                        "Shift Lead",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "SuperAdministrator",
                        "Human Resources Assistant",
                        "Regional Director",
                        "Auditor"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/allADL',
                name: 'All ADL',
                component: AllADL,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/bowel-movement-charting/:clientID',
                name: 'BMC',
                component: BowelMovementCharting,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/chart/:clientID/',
                name: 'BMChart',
                props: true,
                component: BMChart,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientDischarge/:clientID/',
                name: 'Client Discharge',
                component: ClientDischarge,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientDischarge/:clientID/new',
                name: 'Add Client Discharge Form',
                component: ClientDischargeForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientDischarge/:clientID/update/:id',
                name: 'Update Client Discharge Form',
                component: ClientDischargeForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientMove/:clientID/',
                name: 'Client Move',
                component: ClientMove,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientMove/:clientID/new',
                name: 'Add Client Move',
                component: ClientMoveForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/clientMove/:clientID/update/:id',
                name: 'Update Client Move',
                component: ClientMoveForm,
                beforeEnter: (to, from, next) => {
                    const USER_ROLE = [
                        "Administration",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Human Resources Assistant",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "Direct Care Staff",
                        "Regional Director",
                        "Shift Lead",
                        "SuperAdministrator",
                        "Client"
                    ];

                    if (localStorage.getItem('token') && USER_ROLE.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/timesheet/:employeeID',
                name: 'Timesheet',
                component: Timesheet,
            },
            {
                path: '/initialJobPlacement',
                component: InitialJobPlacement,
            },
            {
                path: '/companies',
                name: 'Companies',
                component: Company,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') &&
                        localStorage.getItem('userRole') == "SuperAdministrator"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/companies/:action(add|edit|view)/:id?',
                name: 'CompanyForm',
                component: () => import("@/components/Forms/Company/CompanyForm.vue"),
                props: route => ({
                    action: route.params.action,
                    id: route.params.id
                }),
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') &&
                        localStorage.getItem('userRole') == "SuperAdministrator"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Vehicles',
                name: 'Vehicles',
                component: Vehicles,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/VehicleMaintenance/:employeeID',
                name: 'Vehicle Maintenance',
                component: VehicleMaintenance,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/VehicleMaintenance/:employeeID/:action(add|edit|view)/:id?',
                name: 'Vehicle Maintenance Form',
                component: () => import("@/views/VehicleMaintenance/VehicleMaintenanceForm"),
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/VehicleMaintenanceReport',
                name: 'Vehicle Maintenance Report',
                component: VehicleMaintenanceReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/StaffInventory/:employeeID',
                name: 'StaffInventory',
                component: StaffInventory,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/StaffInventoryReport',
                name: 'StaffInventoryReport',
                component: StaffInventoryReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/ClientInventoryReport',
                name: 'ClientInventoryReport',
                component: ClientInventoryReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/roles',
                name: 'Roles',
                component: Roles,
            },
            {
                path: '/fluid-tracking-charting/:clientID',
                name: 'FluidTracking',
                component: FluidTrackingCharting,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/ft-chart/:clientID/',
                name: 'FTChart',
                props: true,
                component: FTChart,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/ResidentialLog',
                name: 'ResidentialLog',
                component: ResidentialLog,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/MissingClock',
                name: 'Missing Clock Ins',
                component: MissingClock,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/MissingClockOut',
                name: 'Missing Clock Outs',
                component: MissingClockOut,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Transportation',
                name: 'Transportation',
                component: Transportation,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/NevadaInvoice',
                name: 'NevadaInvoice',
                component: NevadaInvoice,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/NevadaBillingReport',
                name: 'NevadaBillingReport',
                component: NevadaBillingReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/CaseManagement/:clientID',
                name: 'Case Management',
                component: CaseManagement,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Ancillary/:clientID',
                name: 'Ancillary',
                component: Ancillary,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/medication-controlled-substance/:clientID/',
                name: 'CS Medication',
                props: true,
                component: MedicationControlledSubstance,

                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/CaseManagementReport',
                name: 'Case Management Report',
                component: CaseManagementReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/AncillaryReport',
                name: 'Ancillary Report',
                component: AncillaryReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/ServiceLog/:clientID',
                name: 'Service Log',
                component: ServiceLog,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/ClientAttendanceReport',
                name: 'Client Attendance Report',
                component: ClientAttendanceReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/Garnishments/:employeeID',
                name: 'Garnishments',
                component: Garnishments,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/Performance/',
                name: 'Performance',
                component: Performance,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/garnishments/:employeeID/:action(add|edit|view)',
                name: 'Garnishment Form',
                component: () => import("@/views/staff/Garnishments/GarnishmentForm"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                        "Administration",
                        "Direct Care Staff",
                        "Shift Lead",
                        "Assistant Manager",
                        "House Manager",
                        "Program Manager",
                        "Human Resources",
                        "Client Services Manager",
                        "Program Coordinator",
                        "Medical Manager",
                        "Executive Director",
                        "Compliance Manager",
                        "Finance Manager",
                        "SuperAdministrator",
                        "Regional Director",
                        "Human Resources Assistant"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/seizure-tracking/:clientID/',
                name: 'Seizure Tracking',
                props: true,
                component: () => import("@/views/client/SeizureTracking"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                    "Administration",
                    "Regional Director",
                    "Shift Lead",
                    "House Manager",
                    "Program Manager",
                    "Human Resources",
                    "Client Services Manager",
                    "Program Coordinator",
                    "Medical Manager",
                    "Executive Director",
                    "Compliance Manager",
                    "Finance Manager",
                    "SuperAdministrator",
                    "Human Resources Assistant",
                    "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/seizure-tracking/:clientID/chart',
                name: 'Seizure Tracking Chart',
                props: true,
                component: () => import("@/views/client/SeizureTracking/chart"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                    "Administration",
                    "Regional Director",
                    "Shift Lead",
                    "House Manager",
                    "Program Manager",
                    "Human Resources",
                    "Client Services Manager",
                    "Program Coordinator",
                    "Medical Manager",
                    "Executive Director",
                    "Compliance Manager",
                    "Finance Manager",
                    "SuperAdministrator",
                    "Human Resources Assistant",
                    "Auditor"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/water-temperature-tracking/:employeeID/',
                name: 'Water Temperature Tracking',
                props: true,
                component: () => import("@/views/employee/WaterTemperatureTracking"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                    "Administration",
                    "Regional Director",
                    "Shift Lead",
                    "House Manager",
                    "Program Manager",
                    "Human Resources",
                    "Client Services Manager",
                    "Program Coordinator",
                    "Medical Manager",
                    "Executive Director",
                    "Compliance Manager",
                    "Finance Manager",
                    "SuperAdministrator",
                    "Human Resources Assistant"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/water-temperature-tracking/:employeeID/chart',
                name: 'Water Temperature Tracking Chart',
                props: true,
                component: () => import("@/views/employee/WaterTemperatureTracking/chart"),
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    const AUTHORIZED_ROLE = [
                    "Administration",
                    "Regional Director",
                    "Shift Lead",
                    "House Manager",
                    "Program Manager",
                    "Human Resources",
                    "Client Services Manager",
                    "Program Coordinator",
                    "Medical Manager",
                    "Executive Director",
                    "Compliance Manager",
                    "Finance Manager",
                    "SuperAdministrator",
                    "Human Resources Assistant"
                    ];

                    if (token && AUTHORIZED_ROLE.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/Billing',
                name: 'Billing',
                component: Billing,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            {
                path: '/programs',
                name: 'Programs',
                component: Programs,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },

            {
                path: '/ResidentialServiceLog',
                name: 'Residential Service Log',
                component: ResidentialServiceLog,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/shift-reports',
                name: 'Shift Reports',
                component: StaffShiftReports,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/programDashboard/:programID',
                name: 'Program Dashboard',
                component: ProgramDashboard,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Super Administrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/programDocuments/:programID',
                name: 'ProgramDocuments',
                component: ProgramDocuments,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Super Administrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/programMaintenance/:programID',
                name: 'ProgramMaintenance',
                component: ProgramMaintenance,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Super Administrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/ProgramInventory/:programID',
                name: 'ProgramInventory',
                component: ProgramInventory,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Auditor"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            {
                path: '/programFireDrill/:programID',
                name: 'Program Fire Drill',
                component: ProgramFireDrill,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "Program Manager"
                        || localStorage.getItem('userRole') == "Human Resources"
                        || localStorage.getItem('userRole') == "Client Services Manager"
                        || localStorage.getItem('userRole') == "Program Coordinator"
                        || localStorage.getItem('userRole') == "Medical Manager"
                        || localStorage.getItem('userRole') == "Executive Director"
                        || localStorage.getItem('userRole') == "Compliance Manager"
                        || localStorage.getItem('userRole') == "Finance Manager"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                        || localStorage.getItem('userRole') == "Regional Director"
                        || localStorage.getItem('userRole') == "Human Resources Assistant"
                        || localStorage.getItem('userRole') == "Super Administrator"
                        || localStorage.getItem('userRole') == "Direct Care Staff"
                        || localStorage.getItem('userRole') == "Shift Lead"
                        || localStorage.getItem('userRole') == "Assistant Manager"
                        || localStorage.getItem('userRole') == "House Manager"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }

            },
            // Roles and Permission
            {
                path: '/roles-permission',
                name: 'Roles and Permission',
                component: RolesPermission,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && localStorage.getItem('userRole') == "Administration"
                        || localStorage.getItem('userRole') == "SuperAdministrator"
                    ) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            //New Routes for Data Tracking Sheets
            {
                path: '/jdt-progress-report/:clientID',
                name: 'JDT Progress Report',
                component: JDTProgressReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/sla-progress-report/:clientID',
                name: 'SLA Progress Report',
                component: SLAProgressReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/rss-logs-24/:clientID',
                name: 'RSS Logs',
                component: RSSLog24,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/jdt-attendance-logs/:clientID',
                name: 'JDT Attendance Logs',
                component: JDTAttendanceLogs,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/rss-interminate-support-logs/:clientID',
                name: 'RSS Support Logs',
                component: RSSInterminateSupportLogs,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/supplemental-residental-support-services/:clientID',
                name: 'Support Services',
                component: SupplmentalResidentialSupport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/new/calendar',
                name: 'Calendar New',
                component: () => import('../views/NewCalendar'),
                children: [
                    {
                        path: 'callback',
                    },
                ],
                beforeEnter: (to, from, next) => {
                    const token = localStorage.getItem('token');
                    const userRole = localStorage.getItem('userRole');
                    if (token && (userRole === "Administration" || userRole === "SuperAdministrator")) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            //New Routes for Data Tracking Sheets
            {
                path: '/JDTAttendanceReport',
                name: 'JDT Attendance Log Report',
                component: JDTAttendanceLogReport,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('token') && STAFF_ROLES.includes(localStorage.getItem('userRole'))){
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },

            /* - - - - - Compensations/Deductions Pages - - - - - */
            {
                path: '/raises/:employeeID',
                name: 'Raise',
                component: Raise,
                beforeEnter: (to, from, next) => {
                    const userRole = localStorage.getItem('userRole');
                    const token = localStorage.getItem('token');
                    const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                    if (token && AUTHORIZED_ROLES.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/raises/:employeeID/:action(add|edit|view)',
                name: 'Raise Form',
                component: () => import("@/views/staff/Raises/RaiseForm"),
              beforeEnter: (to, from, next) => {
                  const userRole = localStorage.getItem('userRole');
                  const token = localStorage.getItem('token');
                  const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                  if (token && AUTHORIZED_ROLES.includes(userRole)) {
                      next();
                  } else {
                      next('/secure');
                  }
              }
            },

            {
                path: '/bonuses/:employeeID',
                name: 'Bonus',
                component: Bonus,
              beforeEnter: (to, from, next) => {
                  const userRole = localStorage.getItem('userRole');
                  const token = localStorage.getItem('token');
                  const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                  if (token && AUTHORIZED_ROLES.includes(userRole)) {
                      next();
                  } else {
                      next('/secure');
                  }
              }
            },
            {
                path: '/bonuses/:employeeID/:action(add|edit|view)',
                name: 'Bonus Form',
                component: () => import("@/views/staff/Bonus/BonusForm"),
              beforeEnter: (to, from, next) => {
                  const userRole = localStorage.getItem('userRole');
                  const token = localStorage.getItem('token');
                  const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                  if (token && AUTHORIZED_ROLES.includes(userRole)) {
                      next();
                  } else {
                      next('/secure');
                  }
              }
            },
            {
                path: '/healthcare/:employeeID',
                name: 'Health Care',
                component: HealthCare,
              beforeEnter: (to, from, next) => {
                  const userRole = localStorage.getItem('userRole');
                  const token = localStorage.getItem('token');
                  const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                  if (token && AUTHORIZED_ROLES.includes(userRole)) {
                      next();
                  } else {
                      next('/secure');
                  }
              }
            },
            {
                path: '/healthcare/:employeeID/:action(add|edit|view)',
                name: 'Health Care Form',
                component: () => import("@/views/staff/HealthCare/HealthcareForm"),
                beforeEnter: (to, from, next) => {
                    const userRole = localStorage.getItem('userRole');
                    const token = localStorage.getItem('token');
                    const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                    if (token && AUTHORIZED_ROLES.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/incentives/:employeeID',
                name: 'Incentives',
                component: Incentives,
                beforeEnter: (to, from, next) => {
                    const userRole = localStorage.getItem('userRole');
                    const token = localStorage.getItem('token');
                    const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                    if (token && AUTHORIZED_ROLES.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            {
                path: '/incentives/:employeeID/:action(add|edit|view)',
                name: 'Incentives Form',
                component: () => import("@/views/staff/Incentives/IncentiveForm"),
                beforeEnter: (to, from, next) => {
                    const userRole = localStorage.getItem('userRole');
                    const token = localStorage.getItem('token');
                    const AUTHORIZED_ROLES = ["SuperAdministrator", "Administration", "Human Resources"];

                    if (token && AUTHORIZED_ROLES.includes(userRole)) {
                        next();
                    } else {
                        next('/secure');
                    }
                }
            },
            /** - - - - - - - - - - - - - - - - - - - - - - - - - */

        ]
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
    },
    {
        path: '/reset-password/:token?',
        name: 'ResetPassword',
        component: ResetPassword,
    },
    {
        path: '/privacy-policy',
        name: 'Privacy',
        component: PrivacyPage,
    },
        {
        path: '/terms-of-service',
        name: 'TermsOfService',
        component: TermsOfService,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.afterEach(to => {
    if (to.fullPath != '/') {
        localStorage.setItem('lastPage', to.fullPath);
    }
  });

export default router
